import styled from '@emotion/styled'

export const InstructionText = styled.div`
    color: var(--Core-Color-Legacy-Black, #000);
    font-family: 'Source Sans Pro';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`

export const LoaderOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 10;
    border-radius: 4px;
    pointer-events: none;
`

export const Spinner = styled.div`
    border: 3px solid #d7dde6;
    border-top: 3px solid #37465b;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 0.8s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`

